// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#panel main .topbar{background-color:var(--color1)}", "",{"version":3,"sources":["webpack://./resources/vue/ThePanel.vue"],"names":[],"mappings":"AAIA,oBACI,8BAHJ","sourcesContent":["\n$color1: var(--color1);\n$color2: var(--color2);\n\n#panel main .topbar {\n    background-color: $color1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
